<template>
  <div></div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PreLogout',
  async mounted () {
    console.log('[PreLogout] MOUNTED - Starting logout process')

    // Clear all Vuex state FIRST (like SessionExpired does)
    try {
      this.$store.dispatch('clearRecentException')
      this.$store.dispatch('brochure/setGuestUser', null)
      this.$store.dispatch('user/logout')
      this.$store.dispatch('app/logout')
      await this.$store.dispatch('RESET_OVB').catch(() => {
        // Ignore errors
      })
    } catch (e) {
      // Ignore errors - we're logging out anyway
      console.error('[PreLogout] Error during state cleanup:', e)
    }

    // Call server logout endpoint to clear session
    try {
      await axios.get('/logout', { withCredentials: true })
    } catch (e) {
      // Ignore errors - session might already be expired
      console.log('[PreLogout] Logout endpoint error (expected):', e.message)
    }

    // IMPORTANT: Clear the global overlay BEFORE redirecting
    // The overlay state is persisted in Vuex localStorage, so we need to clear it
    await this.$store.dispatch('application/setGlobalLoading', {
      show: false,
      message: ''
    })

    // Redirect to home page with logout indicator
    // This prevents GraphQL 401 errors from homepage components trying to load
    console.log('[PreLogout] Redirecting to home page')
    window.location.href = '/?logout=success'
  }
}
</script>

<style scoped>

</style>
